import { UtilsEnum } from '@/utils/UtilsEnum';

/**
 * Enum para os status de análise automática.
 *
 * @remarks
 * **Nota**: os valores estão ordenados conforme a sua prioridade de exibição.
 *
 * @type {EnumType<
 * 'OPCIONAL' |
 * 'EXCECAO' |
 * 'INVALIDO' |
 * 'EXPIRADO' |
 * 'INATIVO' |
 * 'DUPLICADO' |
 * 'DIVERGENTE' |
 * 'SEM_DIVERGENCIA'
 * >}
 */
export const ANALISE_AUTOMATICA_STATUS = UtilsEnum.create({
  OPCIONAL: { value: 'OPCIONAL', description: 'Opcional' },
  EXCECAO: { value: 'EXCECAO', description: 'Exceção' },
  SEM_DIVERGENCIA: { value: 'SEM_DIVERGENCIA', description: 'Sem divergência' },
  DIVERGENTE: { value: 'DIVERGENTE', description: 'Divergente' },
  INVALIDO: { value: 'INVALIDO', description: 'Inválido' },
  DUPLICADO: { value: 'DUPLICADO', description: 'Duplicado' },
  EXPIRADO: { value: 'EXPIRADO', description: 'Expirado' },
  INATIVO: { value: 'INATIVO', description: 'Inativo' },
});
